export default {
  discount_types: {
    cashback: 'Pontos de fidelidade',
    promo_code: 'Código promocional',
  },
  input: {
    label: '{{cashbackLabel}} ou {{promoCodeLabel}}',
    placeholder: 'Código promocional',
  },
  buttons: {
    apply: 'Aplicar',
    remove: 'Remover',
  },
  feedback: {
    login:
      '<highlight>Inicie sessão</highlight> para usar esta promoção e confirmarmos que ainda não foi utilizada. Inicie sessão e tente novamente.',
    usage_threshold: 'O valor mínimo do carrinho para esta promoção é (excl. custos de entrega)',
    promo_code_added: 'Código promocional aplicado com sucesso',
  },
};
